var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStandardLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91797 5.40365C2.91797 3.14615 4.7438 1.32031 7.0013 1.32031C9.2588 1.32031 11.0846 3.14615 11.0846 5.40365C11.0846 7.83615 8.5063 11.1903 7.45047 12.4678C7.21714 12.7478 6.7913 12.7478 6.55797 12.4678C5.4963 11.1903 2.91797 7.83615 2.91797 5.40365ZM5.54297 5.40365C5.54297 6.20865 6.1963 6.86198 7.0013 6.86198C7.8063 6.86198 8.45964 6.20865 8.45964 5.40365C8.45964 4.59865 7.8063 3.94531 7.0013 3.94531C6.1963 3.94531 5.54297 4.59865 5.54297 5.40365Z",
    fill: "#C51F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStandardLocation);
export default __webpack_public_path__ + "static/media/iconStandardLocation.3e24176abe20d0967635ae9f2d89a92c.svg";
export { ForwardRef as ReactComponent };